<footer class="footer">
    <div class="footer-container">
        <!-- Sección Izquierda - Logo y Descripción -->
        <div class="footer-info">
            <img src="assets/logo.png" alt="Logo" class="footer-logo">
            <!--<p>Tropilleros - Soluciones digitales para tu negocio.</p>-->
        </div>

        <!-- Sección Derecha - Redes Sociales -->
        <div class="footer-social">
            <h4>Seguinos</h4>
            <a href="https://es-la.facebook.com/TropillerosOficial/" target="_blank"><i class="fab fa-facebook"></i></a>
            <a href="https://www.instagram.com/tropillerosoficial/" target="_blank"><i class="fab fa-instagram"></i></a>
            <a href="https://open.spotify.com/intl-es/artist/2yRSIO9AuKlZHOwK5StQEx" target="_blank"><i class="fab fa-spotify"></i></a>
            <a href="https://www.youtube.com/c/tropillerosoficial" target="_blank"><i class="fab fa-youtube"></i></a>
        </div>
    </div>

    <!-- Derechos de Autor -->
    <div class="footer-bottom">
        <p>&copy; 2025 Tropilleros. Todos los derechos reservados.</p>
    </div>
</footer>